import { UIManager } from "@/Imports"
//import WinningsManager from "@/managers/winnings/WinningsManager"
import AutoplayManager from "@/managers/autoplay/AutoplayManager";
import Facade from "@/Facade";
import GameFieldManager from "@/managers/field/GameFieldManager";
import SoundsHandling from "@/managers/sound/SoundsHandling";
import BaseSoundManager from "@/managers/sound/BaseSoundManager";
import BalanceManager from "@/managers/balance/BalanceManager";

export default class GameManager {

  constructor (dataField) {
    this.uiManager = new UIManager()
    //this.winningsManager = new WinningsManager()
    this.gameFieldManager = new GameFieldManager(dataField)
    Facade.AutoPlaySettings = new AutoplayManager()
    Facade.BalanceManager = new BalanceManager()

  }
}
